import { render, staticRenderFns } from "./wallet-table.vue?vue&type=template&id=2e10fae4&"
import script from "./wallet-table.vue?vue&type=script&lang=ts&"
export * from "./wallet-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports